export function translateFilter() {
  return i18n
}

